import { render, staticRenderFns } from "./order-index.vue?vue&type=template&id=06004357&"
import script from "./order-index.vue?vue&type=script&lang=js&"
export * from "./order-index.vue?vue&type=script&lang=js&"
import style0 from "./order-index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports